/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import React from 'react';

import { breakpoints } from '@coursera/cds-core';

const styles = {
  shimmer: css`
    background: linear-gradient(
      90deg,
      var(--cds-color-grey-200) 0%,
      var(--cds-color-grey-100) 25%,
      var(--cds-color-grey-200) 50%,
      var(--cds-color-grey-100) 75%
    );
    background-size: 200% 100%;
    animation: shimmer 1.5s infinite;
    border-radius: var(--cds-border-radius-50);

    @keyframes shimmer {
      0% {
        background-position: -200% 0;
      }

      100% {
        background-position: 200% 0;
      }
    }
  `,
  shimmerNumber: css`
    width: 40px;
    height: 20px;
    ${breakpoints.up('md')} {
      margin-top: var(--cds-spacing-50);
      margin-bottom: var(--cds-spacing-50);
    }
  `,
  shimmerLabel: css`
    width: 60px;
    height: 16px;
    ${breakpoints.up('md')} {
      margin-top: var(--cds-spacing-50);
      margin-bottom: var(--cds-spacing-50);
    }
  `,
  shimmerLabelSmallScreen: css`
    width: 50px;
    height: 16px;
  `,
};

type ValuePropositionItemPlaceholderProps = {
  isSmallScreenLayout: boolean;
};

const ValuePropositionItemPlaceholder = ({ isSmallScreenLayout }: ValuePropositionItemPlaceholderProps) => {
  if (isSmallScreenLayout) {
    return (
      <React.Fragment>
        <div css={[styles.shimmer, styles.shimmerNumber]} />
        <div css={[styles.shimmer, styles.shimmerLabelSmallScreen]} />
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <div css={[styles.shimmer, styles.shimmerNumber]} />
      <div css={[styles.shimmer, styles.shimmerLabel]} />
    </React.Fragment>
  );
};

export default ValuePropositionItemPlaceholder;
